import moment from 'moment'

const isWeekendDay = (date: any) => {
  moment.locale('en')
  const fridey = moment(date).format('YYYY-MM-DD')

  return (
    date.getDay() === 5 && !(fridey === '2024-12-06' || fridey === '2024-11-29')
  )
}

const isTursday = (date: any) => {
  return date.getDay() === 4
}

const isSaturday = (date: any) => {
  return date.getDay() === 6
}

export { isWeekendDay, isTursday, isSaturday }
